import { formatCurrency } from '@/utils/format-currency'
import type { Deal } from '@/types'
import { InfoField } from '../InfoField'
import { DealProposalPlatformField } from './DealProposalPlatformField'

function displayDealMeta(value?: string | number | null): string {
  if (value === undefined || value === null) return '—'
  if (typeof value === 'number' && value === 0) return '—'
  const text = String(value).trim()
  if (!text || text === '0') return '—'
  return text
}

function hasCompositionValues(deal: Deal): boolean {
  return (
    Number(deal.valorMensal) > 0 ||
    Number(deal.valorSetup) > 0 ||
    Number(deal.desconto) > 0
  )
}

export function DealProposalSummary({
  deal,
  onDealPatched,
}: {
  deal: Deal
  onDealPatched: (updates: Partial<Deal>) => void
}) {
  return (
    <>
      <div className="glass-card space-y-2 p-4">
        <h3 className="text-xs font-bold uppercase tracking-wider text-accent">Resumo do Negócio</h3>
        <div className="grid grid-cols-2 gap-3">
          <InfoField label="Empresa" value={deal.empresaNome} />
          <InfoField label="Valor" value={formatCurrency(deal.valor)} />
          <InfoField label="Serviço" value={displayDealMeta(deal.servico)} />
          <InfoField label="Recorrência" value={displayDealMeta(deal.recorrencia)} />
          <DealProposalPlatformField
            key={deal.id}
            deal={deal}
            onSaved={(plataforma) => onDealPatched({ plataforma })}
          />
        </div>
      </div>

      {hasCompositionValues(deal) ? (
        <div className="glass-card space-y-2 p-4">
          <h3 className="text-xs font-bold uppercase tracking-wider text-accent">Composição de Valor</h3>
          <div className="grid grid-cols-3 gap-3">
            {Number(deal.valorMensal) > 0 ? (
              <InfoField label="Valor Mensal" value={formatCurrency(deal.valorMensal!)} />
            ) : null}
            {Number(deal.valorSetup) > 0 ? (
              <InfoField label="Setup" value={formatCurrency(deal.valorSetup!)} />
            ) : null}
            {Number(deal.desconto) > 0 ? (
              <InfoField label="Desconto" value={`${deal.desconto}%`} />
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  )
}
